<template>
  <div class="ErrorList">
    <el-dialog
        :title="$t('amazon.amazon12')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
        width="460px"
        center
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('amazon.amazon12')" prop="one">
            <el-input-number size="small" v-model="ruleForm.warningQuantity" :controls="false"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button class="form-btn btn-blue" @click="submitForm('ruleForm')">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "SetGoodsValue",
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      ruleForm: {
        sellingPartnerId: undefined,
        asin: undefined,
        fnSku: undefined,
        warningQuantity: undefined
      },
      rules: {
        warningQuantity: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.ruleForm = this.row
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post(
              "aws/amazonInventory/saveWarningQuantity",
              this.ruleForm
          ).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              // 父组件更新使用
              this.$options.confirm(true)
            }});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__footer){
    padding: 0 20px 20px;
  }
  .el-input-number {
    width: 100%;
    :deep(.el-input__inner){
      text-align: left;
    }
  }
}

</style>
